import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { ProductoService } from '../../servicios/producto.service'
import { MatDialog } from '@angular/material/dialog';
import { ModalCarritoProductosComponent } from '../../componentes/modal-carrito-productos/modal-carrito-productos.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {

	constructor(
		public globals: Globals,
		private productoService: ProductoService,
		private activatedRoute: ActivatedRoute,
		public dialog: MatDialog,
	) { }

  formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  carritoProductos(){
    const dialogRef = this.dialog.open(ModalCarritoProductosComponent, {
      width: '600px',
      maxWidth: '100%'
    });
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      if (params.cotizacion_id != null) {
        return ;
      }
      
      if (params.vendedor != null) {
        this.globals.configuracion.front.vendedor = params.vendedor;
      }
      if (params.modoPrecio != null) {
        if (params.modoPrecio == "mayor") {
          this.globals.configuracion.front.typeabbrev = "02";
        }
        if (params.modoPrecio == "detal") {
          this.globals.configuracion.front.typeabbrev = "01";
        }
      }

      this.globals.setDataFront();

      if( this.globals.configuracion.dataToken.token != null ){
        this.productoService.productosCheckToken().subscribe(
          resultado =>{
            if( !resultado.error ){
              this.globals.setDataToken( resultado.dataToken );

              var total = 0;
              for( let x = 0; x < this.globals.configuracion.front.cart.productos.length; x++ ){
                let indexProducto = resultado.dataToken.app.cart.productos.find( element => element.stockid == this.globals.configuracion.front.cart.productos[x].stockid );
                if( indexProducto !== undefined ){
                  let cantidad = this.globals.configuracion.front.cart.productos[x].cantidad;
                  this.globals.configuracion.front.cart.productos[x] = indexProducto;
                  this.globals.configuracion.front.cart.productos[x].cantidad = cantidad;

                  total += this.globals.configuracion.front.cart.productos[x].precio_final_con_impuesto * this.globals.configuracion.front.cart.productos[x].cantidad;
                }
              }
    
              this.globals.configuracion.front.cart.total = this.formatter.format( total );
              this.globals.setDataFront();
    
            }else{
              //console.log("Error",resultado.mensaje);
            }
          },
          error =>{
            //console.log("Error",error);
          }
        )
    
      }
    })
  }

}
